import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

export const setMonitoring = (service, plant, user) => {
  const env = process.env.REACT_APP_ENV;

  if (service && env !== 'local') {
    datadogRum.init({
      applicationId: '383b9fcb-c226-41fa-992b-f8da6642c470',
      clientToken: 'pub51a8c414dd1528354ef74922f78561ce',
      site: 'us5.datadoghq.com',
      service,
      env,
      version: process.env.REACT_APP_VERSION,
      sessionSampleRate: 100,
      premiumSampleRate: 100,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'allow',
      allowedTracingUrls: ['https://api.concretego.com', /https:\/\/api-.*\.concretego.com/],
    });

    if (user) {
      datadogRum.startSessionReplayRecording();
      setDatadogLogger();

      datadogRum.setUser({
        id: user.id,
        email: user.email,
        name: `${user.name || user.login} -> ${plant}`,
      });

      datadogLogs.setGlobalContext({
        plant: plant,
        userId: user.id,
        userEmail: user.email,
      });
    }
  }

};

export const setDatadogLogger = () => {
  datadogLogs.init({
    clientToken: 'pub51a8c414dd1528354ef74922f78561ce',
    site: 'us5.datadoghq.com',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });

  function patchConsoleMethod(method) {
    const originalMethod = console[method];

    if (!console[method].__datadogPatched) {
      console[method] = function (...args) {
        datadogLogs.logger[method](args.map(arg => JSON.stringify(arg)).join(' '));
        originalMethod.apply(console, args);
      };

      console[method].__datadogPatched = true;
    }
  }

  ['info', 'warn', 'error'].forEach(method => {
    patchConsoleMethod(method);
  });
};
